import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Diagnostico() {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('diag_title')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('diag_subtitle')}
          </p>
        </div>

        <div className="bg-white rounded-xl p-8 shadow-lg">
          <h2 className="text-2xl font-semibold mb-6 text-center">{t('diag_subtitle')}</h2>
          
          <div className="space-y-8">
            {[
              { step: 1, title: t('diag_step1'), icon: "ri-heart-pulse-line", color: "blue" },
              { step: 2, title: t('diag_step2'), icon: "ri-code-line", color: "green" },
              { step: 3, title: t('diag_step3'), icon: "ri-eye-line", color: "purple" },
              { step: 4, title: t('diag_step4'), icon: "ri-radar-line", color: "orange" },
              { step: 5, title: t('diag_step5'), icon: "ri-settings-4-line", color: "red" },
              { step: 6, title: t('diag_step6'), icon: "ri-restart-line", color: "indigo" },
              { step: 7, title: t('diag_step7'), icon: "ri-file-text-line", color: "emerald" },
              { step: 8, title: t('diag_step8'), icon: "ri-shield-check-line", color: "pink" }
            ].map((step, index) => (
              <div key={index} className="relative">
                <div className="flex items-start space-x-6">
                  <div className={`flex-shrink-0 w-16 h-16 bg-${step.color}-100 rounded-full flex items-center justify-center`}>
                    <div className={`w-8 h-8 bg-${step.color}-600 rounded-full flex items-center justify-center text-white font-bold`}>
                      {step.step}
                    </div>
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center space-x-3 mb-2">
                      <div className={`w-8 h-8 flex items-center justify-center bg-${step.color}-100 rounded-lg`}>
                        <i className={`${step.icon} text-${step.color}-600`}></i>
                      </div>
                      <h3 className="text-xl font-semibold">{step.title}</h3>
                    </div>
                  </div>
                </div>
                {index < 7 && (
                  <div className="absolute left-8 top-16 w-0.5 h-8 bg-gray-300"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Link 
            to="/problemas"
            className="flex items-center text-blue-600 hover:text-blue-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_problems')}
          </Link>
          <Link 
            to="/engenheiro"
            className="flex items-center bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('nav_engineer')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}
